export default {
      id: "close-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#close",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = 60
// module chunks = 241 242 243